// composables/useToast.js
import { getCurrentInstance } from "vue";

export function useToast() {
  const inst = getCurrentInstance();
  return inst.appContext.config.globalProperties.$toast;
}
